<template>
  <div>
    <!-- Result Content -->
    <div class="row justify-content-center">
      <div class="card shadow customs-card">
        <!-- Result Label -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">
            結果発表
          </p>
        </div>

        <div
          class="card-body p-4 d-flex align-items-center justify-content-center"
        >
          <img
            :src="campaign.image_of_content_win"
            alt="image_of_content_lose"
            class="img-fluid mx-auto d-block"
          />
        </div>

        <div class="card-footer border-0 mb-4">
          <div class="row">
            <div class="col-12 mb-3">
              <p
                class="m-0 text-center font-weight-bold"
                style="font-size: 2rem !important; color: #ee3618 !important"
              >
                <span v-if="campaign.num_of_repetition > 1"
                  >{{ campaign.num_of_repetition }}回目あたり! !</span
                >
                <span v-else>あたり! !</span>
              </p>
              <p
                class="m-0 text-center text-danger font-weight-bold"
                style="font-size: 1.5rem !important; color: #ee3618 !important"
              >
                当選おめでとうございます!
              </p>
            </div>

            <div class="col-12 mt-2">
              <button
                type="button"
                @click="$router.push({ path: 'prize' })"
                class="btn btn-block background-danger border-0 text-white"
                style="border-radius: 1rem"
              >
                <p class="m-0 text-bold font-weight-bold">ギフトを確認する</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCampaignContents,
  getCampaignImageContents,
  getCampaignCautions,
  getPrize,
} from "@/utils/campaign";
import { setErrorMessage } from "@/utils/error";

import Cautions from "@/components/Cautions.vue";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      campaign: {
        name: "",
        image_of_content_top: "",
        image_of_content_win: "",
        num_of_repetition: 0,
      },
      cautions: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    //check prize existences if player win
    if (!getPrize()) {
      // switch to /game-lose if player lose
      return next("/game-lose");
    }

    // add image url list
    const imagesList = [
      require("@/assets/img/campaign/image_of_content_top.jpg"),
      require("@/assets/img/campaign/image_of_content_win.jpg"),
    ];

    // get campaign image url from cookies
    const imageContents = getCampaignImageContents();

    // push campaign image to imagesList array
    if (imageContents) {
      imageContents.forEach((image) => {
        if (image && (image.type === 20)) {
          // add only content win image to imagesList - 20
          const imageUrl = process.env.BASE_API + image.image_of_content;
          imagesList.push(imageUrl);
        }
      });
    }

    // load every image
    const images = imagesList.map((imageSrc) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = imageSrc;
        img.onload = resolve;
        img.onerror = reject;
      });
    });

    Promise.all(images)
      .then(() => {
        console.log("All images loaded!");
      })
      .catch((error) => {
        console.error("Error getting image", error);
      })
      // TODO: solve the problem when one of all images not loaded and call next right away before loading all
      .finally(() => {
        return next((vm) => {
          // set caution data
          vm.setCampaignCautions(getCampaignCautions());
        });
      });
  },
  created() {
    const contents = getCampaignContents();
    const imageContents = getCampaignImageContents();

    // check campaign content existences from cookies and apply to data
    if (contents) {
      this.campaign.name = contents.name || "";
      this.campaign.num_of_repetition = contents.num_of_repetition || 0;
    }

    // check campaign image content existences from cookies and apply to data
    if (imageContents) {
      imageContents.forEach((image) => {
        if (image && (image.type === 20)) {
          this.campaign.image_of_content_win = process.env.BASE_API + image.image_of_content;
        }
      });
    } else {
      console.error(
        "No image contents found. Changing to default campaign images."
      );
    }
  },
  methods: {
    setCampaignCautions(cautions) {
      this.cautions = cautions;
    },
  },
};
</script>

<style scoped></style>
